<script setup>
import CourseAlphaItem from './CourseAlphaItem.vue';

defineProps({
  letter: {
    type: String,
    required: true,
  },
  courses: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <tr class="courses-section-letter">
    <td colspan="3">
      {{ letter }}
    </td>
  </tr>

  <CourseAlphaItem v-for="course in courses" :key="course.id || course.slug" :course="course" />
</template>

<style scoped></style>
